import { IonButton, IonButtons, IonContent, IonHeader, IonIcon, IonLabel, IonModal, IonTitle, IonToolbar } from "@ionic/react";
import { t } from "i18next";
import { cameraOutline, cropOutline } from "ionicons/icons";
import React, { useEffect, useRef, useState } from "react";
import { debug } from "../../App";
import Cropper from "../Cropper/Cropper";
import {resizeImage} from "../../utils/resizeImage";

export const ImageUploadModal = (props: any) => {
  const modal = useRef<HTMLIonModalElement>(null);
  const inputRef = useRef<HTMLInputElement>(null);
  const [canSave, setCanSave] = useState<boolean>(false);
  const [showCropper, setShowCropper] = useState<boolean>(false);
  const [workingImage, setWorkingImage] = useState<string>(props.currentImage);
  const [finalImage, setFinalImage] = useState<string>(props.currentImage);

  useEffect(() => {
    if (!finalImage) {
      setFinalImage(props.currentImage || "");
    }
  }, [finalImage, props.currentImage]);

  const close = () => {
    modal.current?.dismiss();
  };

  const save = () => {
    props.save(finalImage);
  };

  return (
    <>
      <Cropper
        isOpen={showCropper}
        image={workingImage}
        setImage={(imageBlob: any) => {
          debug("ImageUploadModal", "setImage", imageBlob);
          setShowCropper(false);
          setCanSave(true);
          setFinalImage(imageBlob);
        }}
        closeCropper={() => {
          setShowCropper(false);
        }}
        circle={props.circle}
        options={{
          viewMode: 1,
          aspectRatio: 1,
          cropBoxMovable: false,
          cropBoxResizable: false,
          ...props.options,
        }}
      />
      <IonModal ref={modal} isOpen={props.isOpen} onDidDismiss={props.onDidDismiss}>
        <IonHeader>
          <IonToolbar>
            <IonButtons slot="start">
              <IonButton onClick={close}>{t("close")}</IonButton>
            </IonButtons>
            <IonTitle>{props.title}</IonTitle>
            <IonButtons slot="end">
              <IonButton onClick={save} disabled={!canSave}>
                {t("save")}
              </IonButton>
            </IonButtons>
          </IonToolbar>
        </IonHeader>

        <IonContent className={"ion-padding vertical-center"}>
          <div className={"image-upload-modal"}>
            <img
              src={finalImage}
              alt=""
              className={props.previewImageClassName}
              onClick={() => {
                setShowCropper(true);
              }}
            />

            <IonButtons
              style={{
                justifyContent: "center",
                marginTop: "2em",
              }}
            >
              <IonButton
                fill={"outline"}
                onClick={() => {
                  setShowCropper(true);
                }}
              >
                <IonIcon icon={cropOutline} slot={"start"} />
                <IonLabel>{t("cropPhoto")}</IonLabel>
              </IonButton>

              <IonButton
                fill={"solid"}
                onClick={() => {
                  inputRef.current!.value = "";
                  inputRef.current!.click();
                }}
              >
                <IonIcon icon={cameraOutline} slot={"start"} />
                <IonLabel>{props.addPhotoLabel || t("changePhoto")}</IonLabel>
              </IonButton>
            </IonButtons>

            <div
              style={{
                display: "none",
              }}
            >
              <input
                type="file"
                accept={"image/*"}
                ref={inputRef}
                onChange={async (e) => {
                  // @ts-ignore
                  debug("ImageUploadModal", "onChange", e.target.files[0], showCropper);
                  if (e.target.files && e.target.files[0]) {
                    const resizedImage = await resizeImage(URL.createObjectURL(e.target.files[0]), {
                      maxWidth: 1600,
                      maxHeight: 1600,
                      contentType: "image/png",
                      quality: 1
                    });
                    //@ts-ignore
                    setWorkingImage(resizedImage.url);
                    setShowCropper(true);
                  } else {
                    setWorkingImage("");
                  }
                }}
              />
            </div>
          </div>
        </IonContent>
      </IonModal>
    </>
  );
};
